import { render, staticRenderFns } from "./SelectServiceStatus.vue?vue&type=template&id=639a105d&scoped=true&"
import script from "./SelectServiceStatus.vue?vue&type=script&lang=js&"
export * from "./SelectServiceStatus.vue?vue&type=script&lang=js&"
import style0 from "./SelectServiceStatus.vue?vue&type=style&index=0&id=639a105d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639a105d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
